export default __webpack_public_path__ + "static/media/arrow_left.a25fd436.svg";